<template>
  <div class="bg-white">
    <header class="py-10">
      <div class="md:flex md:items-center md:justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
            Student Dataloads
          </h2>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <span class="ml-3 shadow-sm rounded-md">
            <RouterLink :to="{name: 'studentDataloadNew'}" tag="button" type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-cardstock-green-600 hover:bg-cardstock-green-500 focus:outline-none focus:ring-cardstock-green focus:border-cardstock-green-700 active:bg-cardstock-green-700 transition duration-150 ease-in-out cursor-pointer">
              New Dataload
            </RouterLink>
          </span>
        </div>
      </div>
    </header>

    <main class="">
      <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">

        <div class=" px-5 py-6 sm:px-6" v-if="needsBlankSlate" >

          <div id="student_dataloads__blank_slate" class="border-2 border-dashed border-gray-200 rounded-lg min-h-96">
            <div class="p-4 flex flex-col items-center justify-center my-24">
              <div class="text-6xl mb-4">👩‍💻</div>
              <div class="font-bold text-lg text-center">No dataloads yet!</div>
              <div class="mt-1 text-sm text-center">Click the button in the top right to load new student data into Cardstock.</div>
            </div>
          </div>

        </div>

        <div class="max-w-7xl mx-auto shadow-lg rounded sm:rounded-lg" v-else>
          <ul>
            <li
              v-for="dataload in studentDataloads"
              :key="dataload.id"
              class="first:rounded-t sm:first:rounded-t-lg
              last:rounded-b sm:last:rounded-b-lg
              border-t border-l border-r
              border-b
              border-gray-200 -mt-px first:mt-0
              block focus-within:outline-none focus-within:bg-gray-50 transition duration-150 ease-in-out"
              :class="{'hover:bg-gray-50': dataload.canCurrentEdit}"
            >

            <router-link
              v-if="dataload.canCurrentEdit"
              :to="{name: 'studentDataloadProcess', params: {id: dataload.id}}"
              class="focus:outline-none"
            >
                <div class="px-4 py-4 flex items-center sm:px-6">
                  <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                      <div class="text-sm leading-5 font-medium text-cardstock-blue-500 truncate">
                        <Get :object="dataload" get="teacher" v-slot="{found}">
                          <span v-if="found">Dataload by <TeacherNameOrYou :teacher="found" v-slot="{display}">{{display}}</TeacherNameOrYou></span>
                          <span v-else>Dataload by <em>unknown</em></span>
                        </Get>
                      </div>
                      <div class="mt-2 flex">
                        <div class="flex items-center text-sm leading-5 text-gray-500">
                          <span>
                            Spreadsheet loaded <TimeAgo :time="dataload.insertedAt"/>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 flex-shrink-0 sm:mt-0">
                      <div class="flex overflow-hidden">
                        <span
                          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-cool-gray-100 text-cool-gray-800"
                          :class="{
                            'bg-cardstock-green-100 text-cardstock-green-800': dataload.status == 'complete',
                            'bg-cardstock-blue-100 text-cardstock-blue-800': dataload.status == 'processing',
                            'bg-cardstock-red-100 text-cardstock-red-800': dataload.status == 'failed',
                            'bg-cardstock-blue-100 text-cardstock-blue-800': dataload.status == 'ready',
                            'bg-cardstock-blue-100 text-cardstock-blue-800': dataload.status == 'uploaded',
                          }"
                        >
                          {{dataload.status}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="ml-5 flex-shrink-0">
                    <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </div>
                </div>
            </router-link>

            <div v-else>
                <div class="px-4 py-4 flex items-center sm:px-6">
                  <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                      <div class="text-sm leading-5 font-medium text-cool-gray-500 truncate">
                        <Get :object="dataload" get="teacher" v-slot="{found}">
                          <span v-if="found">Dataload by <TeacherNameOrYou :teacher="found" v-slot="{display}">{{display}}</TeacherNameOrYou></span>
                          <span v-else>Dataload by <em>unknown</em></span>
                        </Get>
                      </div>
                      <div class="mt-2 flex">
                        <div class="flex items-center text-sm leading-5 text-gray-500">
                          <span>
                            Spreadsheet loaded <TimeAgo :time="dataload.insertedAt"/>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 flex-shrink-0 sm:mt-0">
                      <div class="flex overflow-hidden">
                        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-cool-gray-100 text-cool-gray-800">
                          {{dataload.status}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            </li>

          </ul>
        </div>

      </div>
    </main>

  </div>
</template>

<script>
import { preload } from '@/preloader'
import { tz } from '@/tz'

import StudentDataloadsQuery from '@/queries/StudentDataloads.gql'
import StudentDataloadProcessedSubscription from '@/subscriptions/StudentDataloadProcessed.gql'
import TimeAgo from '@/components/TimeAgo.vue'
import TeacherNameOrYou from '@/snippets/TeacherNameOrYou.vue'
import Get from '@/snippets/Get.vue'

export default {
  components: {
    TimeAgo,
    TeacherNameOrYou,
    Get,
  },

  props: {
    teamId: {
      required: true
    }
  },

  data() {
    return {
      studentDataloads: []
    }
  },

  beforeRouteEnter: (to, from, next) => {
    preload({
      callback: next,
      query: StudentDataloadsQuery,
      queryName: "studentDataloadList",
      variables: {
        tz: tz(),
        teamId: to.params.teamId
      }
    })
  },

  beforeRouteUpdate: (to, from, next) => {
    var pageNumber

    if (to.query.page) {
      pageNumber = parseInt(to.query.page)
    }
    preload({
      mountedVm: this,
      callback: next,
      query: StudentDataloadsQuery,
      queryName: "studentDataloadList",
      variables: {
        tz: tz(),
        teamId: to.params.teamId
      }
    })
  },

  beforeRouteUpdate: (to, from, next) => {
    var pageNumber

    if (to.query.page) {
      pageNumber = parseInt(to.query.page)
    }
    preload({
      callback: next,
      query: StudentListQuery,
      queryName: "studentList",
      mountedVm: this,
      variables: {
        page: pageNumber,
        sortBy: to.query.sortBy,
        sortDirection: to.query.sortDirection,
        teamId: to.params.teamId
      }
    })
  },

  computed: {
    needsBlankSlate() {
      return this.studentDataloads.length == 0
    }
  },

  apollo: {
    studentDataloads: {
      query: StudentDataloadsQuery,
      variables() {
        return {
          tz: tz(),
          teamId: this.teamId
        }
      },
      fetchPolicy: 'cache-first',
      subscribeToMore: {
        document: StudentDataloadProcessedSubscription,
        variables() {
          return {
            tz: tz(),
            teamId: this.teamId,
          }
        }
      }
    }
  }
}
</script>
